<script lang="ts">
  import { Button } from '../common';

  let {
    count = 0,
    onUndo,
    onDismiss
  }: {
    count: number;
    onUndo: () => void;
    onDismiss: () => void;
  } = $props();
</script>

<div class="undo-toast">
  <button class="close-btn" onclick={onDismiss} aria-label="Close">×</button>
  <span class="message">Updated {count} transaction(s)</span>
  <div class="btn-wrapper">
    <Button variant="ghost" size="sm" onclick={onUndo}>Undo</Button>
  </div>
</div>

<style lang="scss">
  @keyframes slideInFromRight {
    from {
      opacity: 0;
      transform: translateX(100%);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .undo-toast {
    position: relative;
    display: flex;
    align-items: center;
    gap: var(--spacing-lg);
    padding: var(--spacing-md) var(--spacing-4xl) var(--spacing-md) var(--spacing-lg);
    background: var(--color-success);
    border-radius: var(--radius-xl);
    box-shadow: var(--shadow-3xl);
    max-width: 420px;
    width: calc(100vw - 48px);
    animation: slideInFromRight 0.3s ease-out;

    .close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
      background: transparent;
      border: none;
      color: rgba(255, 255, 255, 0.8);
      font-size: var(--font-size-2xl);
      line-height: var(--line-height-none);
      cursor: pointer;
      padding: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--spacing-xs);
      transition: all var(--transition-fast);

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        color: white;
      }
    }

    .message {
      color: white;
      font-weight: var(--font-weight-medium);
      font-size: var(--font-size-sm);
    }

    .btn-wrapper {
      flex-shrink: 0;

      :global(button) {
        background: white !important;
        color: var(--color-success) !important;
        border: none !important;

        &:hover {
          background: var(--color-background-tertiary) !important;
        }
      }
    }
  }
</style>
